import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Grid } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import FormControl from '@mui/material/FormControl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import { IDropDownResponse } from '../../models/registration.model';
import { IDropDown } from './IDropDowm';
import './style.css';
export default function CustomisedDropDown({ title, label, setSelectedItem, options, isSelected, rejected }: IDropDown) {
    const css = `
       .MuiTypography-root{
           font-size: 14px;
       }
       `;
    const [open, setOpen] = React.useState(false);


    const theme = useTheme();

    const handleClick = (item: IDropDownResponse) => {
        setOpen(false);
        setSelectedItem(item)
    }

    const handleOpen = () => {
        if (options != null && options != undefined && options.length > 0 && (rejected === false || rejected === undefined || rejected === null)) {
            setOpen(true)
        }
    }


    return (
        <div
            style={{
                background: 'var(--input-bg-color)',
                border: "1px solid var(--border-color)",
            }}
            className="textFieldBorderDesign"
        >
            <FormControl fullWidth>
                <style>{css}</style>
                <Grid
                    container
                    onClick={handleOpen}
                    className="primaryColorLight-100"
                    sx={{
                        margin: 'auto',
                        height: '6svh',
                        alignItems: 'center',
                        fontSize: '14px',
                        paddingRight: "20px",
                        paddingLeft: "15px"
                    }}
                >
                    <Grid xs={9} textAlign={'right'} fontSize={"14px"} style={{ color: isSelected ? "var(--primary-text-color) " : "var(--tirnary-text-color)" }}>
                        {title}
                    </Grid>
                    <Grid xs={3} textAlign={'left'}>
                        <MoreHorizIcon />
                    </Grid>
                </Grid>
            </FormControl>
            <Drawer
                anchor={'bottom'}
                open={open}
                sx={{ zIndex: 1221, }}
                onClose={() => setOpen(false)}
                PaperProps={{
                    style: {
                        backgroundColor: "var(--input-bg-color)",
                    }
                }}

            >
                <Grid
                    container
                    spacing={2}
                    textAlign={'right'}
                    fontSize={'14px'}
                    style={{ justifyContent: "end", paddingBottom: "10px" }}
                    className="  dropTitle  px-5 py-5 pt-8"
                    onClick={() => setOpen(false)}
                    color={'var(--primary-text-color)'}
                >
                    {label}
                </Grid>
                <List>
                    {options.map((item, index) => (
                        <ListItem key={index} disablePadding>
                            <ListItemButton onClick={() => handleClick(item)}>
                                {(item.additionalData != null && item.additionalData != undefined) ?
                                    <div style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}>
                                        <ListItemText
                                            style={{ float: 'left' }}
                                            className=" dirRtl"
                                            primary={item.additionalData}
                                            sx={{ color: 'var(--primary-text-color)' }}
                                        >
                                        </ListItemText>
                                        <ListItemText
                                            style={{ float: 'right' }}
                                            className=" dirRtl"
                                            primary={item.title}
                                            sx={{ color: 'var(--primary-text-color)' }}

                                        >
                                        </ListItemText>

                                    </div>
                                    :
                                    <ListItemText
                                        className=" dirRtl"
                                        sx={{ textAlign: 'center', color: 'var(--primary-text-color)' }}
                                        primary={item.title}
                                        onClick={() => handleClick(item)}


                                    >
                                    </ListItemText>
                                }
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </div>
    );
}
